<template>
  <aside
    :class="[
      'main-sidebar',
      'col-12',
      'col-md-3',
      'col-lg-1',
      'px-0',
      sidebarVisible ? 'open' : ''
    ]"
  >
    <div class="main-navbar">
      <nav
        class="navbar align-items-stretch flex-md-nowrap p-0 gm-logo"
        id="step-1"
      >
        <a class="navbar-brand w-100 mr-0" href="/dashboard">
          <p style="text-align:center;width:100%;">
            <img
              v-if="logo"
              id="main-logo"
              class="d-inline-block align-top"
              style="margin-top: -7px;
    width: 50px;
    zoom: 1;
    height: auto;
    border: 3px solid white;
    border-radius: 5px;"
              :src="logo"
              alt="Shards Dashboard"
            />
          </p>
        </a>
        <a
          class="toggle-sidebar d-sm-inline d-md-none d-lg-none"
          @click="handleToggleSidebar()"
        >
          <i class="material-icons">&#xE5C4;</i>
        </a>
      </nav>
    </div>

    <form
      action="#"
      class="main-sidebar__search w-100 border-right d-sm-flex d-md-none d-lg-none"
    >
      <div class="input-group input-group-seamless ml-3">
        <div class="input-group-prepend">
          <div class="input-group-text">
            <i class="fas fa-search"></i>
          </div>
        </div>
        <input
          class="navbar-search form-control"
          type="text"
          placeholder="Search for something..."
          aria-label="Search"
        />
      </div>
    </form>

    <div class="nav-wrapper">
      <d-nav class="flex-column">
        <li
          v-for="(item, navItemIdx) in items"
          :key="navItemIdx"
          class="nav-item dropdown nav-component"
        >
          <d-link
            :class="[
              'nav-link',
              item.items && item.items.length ? 'dropdown-toggle' : ''
            ]"
            :to="item.to"
            v-d-toggle="`snc-${navItemIdx}`"
          >
            <div
              class="item-icon-wrapper"
              v-if="item.htmlBefore"
              v-html="item.htmlBefore"
            />
            <span v-if="item.title" class="side-title">{{ item.title }}</span>
            <div
              class="item-icon-wrapper"
              v-if="item.htmlAfter"
              v-html="item.htmlAfter"
            />
          </d-link>
          <d-collapse
            v-if="item.items && item.items.length"
            :id="`snc-${navItemIdx}`"
            class="dropdown-menu dropdown-menu-small"
            accordion="sidebar-items-accordion"
          >
            <d-dropdown-item
              v-for="(subItem, subItemIdx) in item.items"
              :key="subItemIdx"
              :href="subItem.href"
              :to="subItem.to"
              >{{ subItem.title }}</d-dropdown-item
            >
          </d-collapse>
        </li>
      </d-nav>
      <!--<d-nav class="flex-column lead-capture">
        <li class="nav-item dropdown nav-component">
          <a
            href="/setup"
            class="nav-link"
            target="_self"
            aria-controls="snc-5"
            aria-expanded="false"
            role="button"
          >
            <div class="item-icon-wrapper">
              <i class="material-icons">web</i>
            </div>
            <span class="side-title">Site Widget</span>
          </a>
        </li>
      </d-nav>-->
    </div>
  </aside>
</template>

<script>
import { mapState } from "vuex";
import settingTypes from "../../../vuex/setting/setting.types";

export default {
  name: "main-sidebar",
  props: {
    /**
     * Whether to hide the logo text, or not.
     */
    hideLogoText: {
      type: Boolean,
      default: false
    },
    /**
     * The menu items.
     */
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      sidebarVisible: false,
      logo: null
    };
  },
  computed: {
    ...mapState({
      type: state => state.setting.type,
      data: state => state.setting.data
    })
  },
  created() {
    this.$eventHub.$on("toggle-sidebar", this.handleToggleSidebar);
    this.$store.dispatch("fetchSetting");
  },
  beforeDestroy() {
    this.$eventHub.$off("toggle-sidebar");
  },
  methods: {
    handleToggleSidebar() {
      this.sidebarVisible = !this.sidebarVisible;
    }
  },
  watch: {
    type(type) {
      if (type === settingTypes.FETCH_SETTING_SUCCESS) {
        this.logo = this.data.setting.logo;
      }
    }
  }
};
</script>

<style lang="scss">
.nav-logo {
  height: 100% !important;
}
.main-Logo {
  height: 15%;
}
.lead-capture {
  position: absolute;
  bottom: 10px;
  /* left: -13px; */
  width: 100%;
}
.main-sidebar {
  .item-icon-wrapper {
    display: inline-block;
  }
  .dropdown-menu {
    display: block;
  }
}
.nav-link {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
  flex-direction: column !important;
}
.main-sidebar .nav .nav-item .nav-link i.material-icons {
  font-size: 2.125rem;
  top: -1px;
  margin-right: 0px;
}
.side-title {
  font-size: 0.7rem;
}
.main-sidebar .nav .nav-item .nav-link.active i {
  color: #ffffff;
}

.side-title {
  color: #232349;
  font-weight: 600;
  color: #fff;
}
.main-sidebar .nav .nav-item .nav-link.active {
  box-shadow: inset 0.1875rem 0 0 #f2557a;
  background-color: #be415f;
  color: #ffffff !important;
}
.main-sidebar .nav-wrapper {
  background-color: #f2557a;
}

.navbar-light {
  background-color: #fff !important;
}
.main-navbar {
  background-color: #fff !important;
  // height: 30%;
}
.main-sidebar .nav .nav-item:hover {
  background-color: #be415f;
  color: #fff;
  box-shadow: inset 0.1875rem 0 0 #f2557a;
}
.main-sidebar .nav .nav-item .nav-link:hover {
  background-color: #be415f;
  color: #fff;
}

.gm-logo {
  background-color: #f2557a;
}
.main-sidebar .nav .nav-item .nav-link {
  border-bottom: none;
}
.main-sidebar .nav .nav-item:hover i,
.main-sidebar .nav .nav-item .nav-link:hover i {
  color: #fff;
  background: none;
}
.bg-color-blue {
  background-color: #232349;
  padding: 5px;
  border: none;
}
</style>
